import { MembershipStatus } from '@govinity/validation';
/**
 * Why a government user can't be selected in a user picker, or null when they can be. Invited
 * users are selectable so work can be assigned before they activate their account.
 */
export var getUserUnavailableReason = function (user) {
    if (user.blockInternalAccess) {
        return 'No staff access';
    }
    if (user.status === MembershipStatus.Disabled) {
        return 'Disabled';
    }
    return null;
};
export var isUserSelectable = function (user) {
    return getUserUnavailableReason(user) === null;
};
